import React from "react";

interface BatchSummaryCardProps {
  batch: {
    id: string;
    eventName?: string | null;
    batchType?: string | null;
    status: string;
    startingCheckNumber: number;
    createdByName: string;
    createdAt: string;
    totalChecks?: number | null;
    totalAmount?: string | null;
    notes?: string;
  };
}

const BatchSummaryCard: React.FC<BatchSummaryCardProps> = ({ batch }) => {
  const displayName =
    batch.batchType === "BONUS"
      ? "Bonus Batch"
      : (batch.eventName ?? "Unknown Event");

  return (
    <div className="border rounded-lg px-6 py-3 mb-2 shadow-sm bg-background">
      <div className="flex flex-wrap justify-between items-center mb-1">
        <div className="flex items-center gap-2">
          <span className="font-semibold text-lg text-foreground">
            {displayName}
          </span>
          {batch.batchType === "BONUS" && (
            <span className="text-xs bg-info/10 text-info rounded-full px-2 py-0.5 font-medium">
              Bonus
            </span>
          )}
        </div>
        <span
          className={`px-2 py-1 rounded text-xs font-bold ${
            batch.status === "FINALIZED"
              ? "bg-success/10 text-success"
              : "bg-warning/10 text-warning"
          }`}
        >
          {batch.status}
        </span>
      </div>
      <div className="text-sm text-muted-foreground mb-0">
        Created by {batch.createdByName} on{" "}
        {new Date(batch.createdAt).toLocaleDateString()}
      </div>
      <div className="flex flex-wrap gap-6 text-sm mt-2">
        <span>
          Starting Check #: <b>{batch.startingCheckNumber}</b>
        </span>
        <span>
          Total Checks: <b>{batch.totalChecks ?? "-"}</b>
        </span>
        <span>
          Total Amount:{" "}
          <b>
            {batch.totalAmount != null && batch.totalAmount !== ""
              ? Number(batch.totalAmount).toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                })
              : "-"}
          </b>
        </span>
      </div>
      {batch.notes && (
        <div className="text-xs text-muted-foreground mt-2">
          Notes: {batch.notes}
        </div>
      )}
    </div>
  );
};

export default BatchSummaryCard;
